<template>
    <p>this is an knowledge point page</p>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>
